import cx from 'classnames';
import { useDroppable } from '@dnd-kit/core';
import style from './style.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const Dropzone = ({
  id,
  children,
  disabled,
  className,
  draggableOverClassName,
  as = 'span',
} = {}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    disabled,
  });
  const Component = as;
  return (
    <Component
      ref={setNodeRef}
      className={cx(style.dropzone, className, {
        [draggableOverClassName]: isOver,
      })}
    >
      {children}
    </Component>
  );
};
